import * as types from '../actions/action-types';

const INITIAL_STATE = {
    alertsLoading: false,
    badgeCount: 0,
    tasksTouched: false,
    pastDue: {
        needsReviewEvents: [],
        needsReviewAfterActions: [],
        returnedForEditEvents: [],
        returnedForEditAfterActions: [],
        incompleteAfterActions: []
    },
    incomplete: {
        events: [],
        afterActions: [],
        assignedAfterActions: []
    },
    needsReview: {
        events: [],
        afterActions: []
    },
    pendingApproval: {
        events: [],
        afterActions: []
    },
    returnedForEdit: {
        events: [],
        afterActions: []
    },
    rejectedEvents: {
        events: []
    }
};

export const getAlertsLoading = state => state.alertsLoading;
export const getTasksTouched = state => state.tasksTouched;
export const getBadgeCount = state => state.badgeCount;
export const getPastDueNeedsReviewEvents = state =>
    state.pastDue.needsReviewEvents;
export const getPastDueNeedsReviewAfterActions = state =>
    state.pastDue.needsReviewAfterActions;
export const getPastDueReturnedForEditEvents = state =>
    state.pastDue.returnedForEditEvents;
export const getPastDueReturnedForEditAfterActions = state =>
    state.pastDue.returnedForEditAfterActions;
export const getPastDueIncompleteAfterActions = state =>
    state.pastDue.incompleteAfterActions;
export const getIncompleteEvents = state => state.incomplete.events;
export const getIncompleteAfterActions = state => state.incomplete.afterActions;
export const getIncompleteAssignedAfterActions = state =>
    state.incomplete.assignedAfterActions;
export const getNeedsReviewEvents = state => state.needsReview.events;
export const getNeedsReviewAfterActions = state =>
    state.needsReview.afterActions;
export const getPendingApprovalEvents = state => state.pendingApproval.events;
export const getPendingApprovalAfterActions = state =>
    state.pendingApproval.afterActions;
export const getReturnedForEditEvents = state => state.returnedForEdit.events;
export const getReturnedForEditAfterActions = state =>
    state.returnedForEdit.afterActions;
export const getRejectedEvents = state => state.rejectedEvents.events;

export default (state = INITIAL_STATE, action) => {
    if (action.type === types.ALERTS_LOADING) {
        return {
            ...state,
            alertsLoading: !state.alertsLoading
        };
    } else if (action.type === types.BADGE_COUNT_SUCCESS) {
        return {
            ...state,
            badgeCount: action.count
        };
    } else if (action.type === types.SET_NEW_TASKS_VISITED) {
        return {
            ...state,
            tasksTouched: true
        };
    } else if (action.type === types.PAST_DUE_SUCCESS) {
        return {
            ...state,
            pastDue: {
                ...state.pastDue,
                ...action.pastDue
            }
        };
    } else if (action.type === types.INCOMPLETE_SUCCESS) {
        return {
            ...state,
            incomplete: {
                ...state.incomplete,
                ...action.incomplete
            }
        };
    } else if (action.type === types.NEEDS_REVIEW_SUCCESS) {
        return {
            ...state,
            needsReview: {
                ...state.needsReview,
                ...action.needsReview
            }
        };
    } else if (action.type === types.PENDING_APPROVAL_SUCCESS) {
        return {
            ...state,
            pendingApproval: {
                ...state.pendingApproval,
                ...action.pendingApproval
            }
        };
    } else if (action.type === types.RETURNED_FOR_EDIT_SUCCESS) {
        return {
            ...state,
            returnedForEdit: {
                ...state.returnedForEdit,
                ...action.returnedForEdit
            }
        };
    } else if (action.type === types.REJECTED_EVENTS_SUCCESS) {
        return {
            ...state,
            rejectedEvents: {
                events: action.payload
            }
        };
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/alerts.js